import OfficeHourable from '../concerns/OfficeHourable'
import Extendable from '../concerns/Extendable'
import RelatedRegisterable from '../concerns/RelatedRegisterable'

export default function Account (subscriptions, officeHourSubscriptions, registrations, lineItemsExtension, user) {
  const self = {
    myCoursesFilter: (subscription) => {
      return !Extendable.isPrevious(lineItemsExtension, subscription) && subscription.isMyCourse(user) && !subscription.isInstructorCourse
    },
    myStudentCoursesFilter: (subscription) => {
      return !Extendable.isPrevious(lineItemsExtension, subscription) && subscription.isMyStudentCourse(user) && !subscription.isInstructorCourse
    },
    instructorCourses: subscriptions.filter((subscription) => {
      return !Extendable.isPrevious(lineItemsExtension, subscription) && subscription.isInstructorCourse
    }),
    previousCourses: subscriptions.filter((subscription) => Extendable.isPrevious(lineItemsExtension, subscription)),
    previousOfficeHourSubscriptions: officeHourSubscriptions.filter((officeHourSubscription) => Extendable.isPrevious(lineItemsExtension, officeHourSubscription)),
    studentCourses: subscriptions.filter((subscription) => subscription.isStudentCourse(user)),
    relatedRegisterableSubscriptions: subscriptions.filter((s) => !RelatedRegisterable.flags(s, user).length),
    teacherEnrollment: subscriptions.find((s) => s.isRoleTeacher),
    myCoursesTitle_flags: [],
    myStudentCoursesTitle_flags: []
  }

  self.myStudentCourses = subscriptions.filter(self.myStudentCoursesFilter)
  self.myCourses = subscriptions.filter(self.myCoursesFilter)
  self.hasInstructorCourses = registrations.length > 0 || self.instructorCourses.length > 0
  const hasOfficeHoursUnassigned = OfficeHourable.unassigned(officeHourSubscriptions, subscriptions, lineItemsExtension).length > 0
  self.hasCourses = self.myCourses.length > 0 ||
                    self.myStudentCourses.length > 0 ||
                    self.hasInstructorCourses ||
                    hasOfficeHoursUnassigned

  if (!self.myCourses.length) {
    self.myCoursesTitle_flags.push("no_my_courses")
  }
  if (!self.myStudentCourses.length && !self.hasInstructorCourses && !hasOfficeHoursUnassigned) {
    self.myCoursesTitle_flags.push("no_my_student_instructor_office_hours")
  }

  if (!self.myStudentCourses.length) {
    self.myStudentCoursesTitle_flags.push("no_my_student_courses")
  }
  if (!self.myCourses.length && !self.hasInstructorCourses && !hasOfficeHoursUnassigned) {
    self.myStudentCoursesTitle_flags.push("no_my_courses_instructor_office_hours")
  }

  return self
}
